import { useEffect } from "react";

import { useIntl } from "react-intl";

import UFOSegment from "@atlaskit/react-ufo/segment";

// import { ProductNavBar } from "@/components/wpl/product-navbar/src";
import { useLocalizedHref } from "@/libraries/web-framework";
import { TypographyStyles } from "@/libraries/wpl/foundations/src";
import { GlobalFooter } from "@/patterns/global-footer/src/index";
import { experiments, useExperimentExposure } from "@/utils/experiment";
import { useFeatureExposed } from "@/utils/feature-exposed";

import { ConfluenceSoftwarePageProps } from "../confluence-software-page.tsx";
import { isTargetedSubAnchor } from "../subAnchors/subAnchor-util.tsx";

import { Arrows } from "./arrows-hero";
import ProductNavBar from "./brand-navbar";
import { PlanSection } from "./featured-card-hero";
import { Integrations } from "./integrations-hero";
import { HeroConfluenceCTA } from "./main-hero";
import { StatisticsHero } from "./statistics-hero";
import { VideoHeroConfluenceSoftwarePageVariantBPSRedesign } from "./video-hero";

export interface ConfluenceSoftwarePageVariantPaidLpXflowRedesignExperimentProps
    extends ConfluenceSoftwarePageProps {
    subAnchor?: string;
}

export const ConfluenceSoftwarePageVariantPaidLpXflowRedesignExperiment = (
    pageProps: ConfluenceSoftwarePageVariantPaidLpXflowRedesignExperimentProps
) => {
    const intl = useIntl();
    const [exposureSubAnchorFired, fireSubAnchorExposure] =
        useExperimentExposure(experiments.cfind3254LandingPageSubAnchor);
    useEffect(() => {
        if (
            isTargetedSubAnchor(pageProps.subAnchor) &&
            !exposureSubAnchorFired
        ) {
            fireSubAnchorExposure();
        }
    }, [exposureSubAnchorFired, fireSubAnchorExposure]);

    const productHref = useLocalizedHref("/software/confluence");
    useFeatureExposed("jsw_xflow_bps_landing_redesign_exp", "experiment");

    return (
        <>
            <UFOSegment name="paid-lp-xflow-redesign-experiment">
                <div>
                    <ProductNavBar
                        {...{
                            productHref,
                            productName: "confluence",
                            ariaLabel: intl.formatMessage({
                                id: "wacConfluenceNavigation.logo-label",
                                defaultMessage: "Confluence logo"
                            }),
                            dataProductKey: "confluence",
                            showFreeHrefButton: true
                        }}
                    />
                    <TypographyStyles>
                        <HeroConfluenceCTA />
                        <VideoHeroConfluenceSoftwarePageVariantBPSRedesign />
                        <PlanSection />
                        <StatisticsHero />
                        <Integrations />
                        <Arrows />
                    </TypographyStyles>
                </div>
            </UFOSegment>
            <GlobalFooter />
        </>
    );
};
